module.exports = __webpack_public_path__ + "static/img/cont59 (3).c57b6e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont59 (3).jpg
// module id = o9fg
// module chunks = 0